import { InputSchemeDefinition } from "./input-types";
import { BackgroundColor } from "../../background/constants/background-types";
import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createInputMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.InputSchemeConfiguration<InputSchemeDefinition> = {};

  AllColors.INPUT_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      borderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      borderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      borderHoverColorActive: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      borderActiveColor: AllColors[`COLOR_SYSTEM_HIGHLIGHT`],
      textColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      textColorActive: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      labelColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      labelColorActive: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      errorMessageColor: AllColors[`COLOR_SYSTEM_ERROR`],
      successColor: AllColors[`COLOR_SYSTEM_SUCCESS`],
      trailingIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      trailingIconColorActive: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      disabledBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_20`],
      disabledBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_80`],
      disabledTrailingIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_60`],
      disabledLabelColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      disabledOpacity: 0.6,
      optionsBackgroundColor: AllColors.COLOR_BRIGHT,
      optionsBorderBottomColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      optionsBackgroundColorHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      background: AllColors.COLOR_TRANSPARENT,
      backgroundActive: AllColors.COLOR_BRIGHT,
      outerBorderColor: AllColors.COLOR_TRANSPARENT,
      highlightedNecessityColor: AllColors[`COLOR_GREY700`],
      highlightedNecessityActiveColor: AllColors[`COLOR_GREY700`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });

  return newSchemes;
}

export const INPUT_SCHEME_CONFIG: AllColors.InputSchemeConfiguration<InputSchemeDefinition> = createSchemes();

export const INPUT_SCHEME_MAP: Map<BackgroundColor | "default", InputSchemeDefinition> = new Map(
  Object.entries(createInputMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    INPUT_SCHEME_CONFIG[config as string]
  ])
);

export const INPUT_EMAIL = "email";
export const INPUT_NUMBER = "number";
export const INPUT_PASSWORD = "password";
export const INPUT_TEL = "tel";
export const INPUT_TEXT = "text";
export const INPUT_SEARCH = "search";
export const INPUT_DATE = "date";
export const INPUT_HIDDEN = "hidden";
export const INPUT_TYPES = [
  INPUT_EMAIL,
  INPUT_NUMBER,
  INPUT_PASSWORD,
  INPUT_TEL,
  INPUT_TEXT,
  INPUT_SEARCH,
  INPUT_DATE,
  INPUT_HIDDEN
] as const;

export const INPUT_CURRENCIES = [
  {
    name: "EUR",
    currencySymbol: "€",
    currencyFormat: "num €",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "USD",
    currencySymbol: "$",
    currencyFormat: "$num",
    thousandSeparator: ",",
    currencyRadix: "."
  },
  {
    name: "GBP",
    currencySymbol: "£",
    currencyFormat: "£num",
    thousandSeparator: ",",
    currencyRadix: "."
  },
  {
    name: "SEK",
    currencySymbol: "kr",
    currencyFormat: "num kr",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "DKK",
    currencySymbol: "kr.",
    currencyFormat: "kr. num",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "CZK",
    currencySymbol: "Kč",
    currencyFormat: "num Kč",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "PLN",
    currencySymbol: "zł",
    currencyFormat: "num zł",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "HUF",
    currencySymbol: "Ft",
    currencyFormat: "num Ft",
    thousandSeparator: ".",
    currencyRadix: ","
  },
  {
    name: "RON",
    currencySymbol: "Lei",
    currencyFormat: "num Lei",
    thousandSeparator: ".",
    currencyRadix: ","
  }
];

export const CURRENCIES_NAMES = ["EUR", "USD", "GBP", "SEK", "DKK", "CZK", "PLN", "HUF", "RON"] as const;

export const NUMBER_REGEX1 = new RegExp(/(^\d*\.?\d*)$|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/);
export const NUMBER_REGEX2 = new RegExp(/[^0-9]/g);

export const INPUT_MODE_OPTIONS = ["none", "text", "decimal", "numeric", "tel", "search", "email", "url"] as const;
